import { tv } from "tailwind-variants";
import {
  RadioProps,
  Radio as RadioRAC,
  composeRenderProps,
} from "react-aria-components";

const styles = tv({
  base: "cursor-pointer group h-34 bg-transparent border-2 border-grey-4 flex items-center rounded-3 w-full sm:px-12 px-5",
  variants: {
    isSelected: {
      true: "bg-grey-1 border-black",
    },
    isHovered: {
      true: "",
    },
    isFocusVisible: {
      true: "",
    },
  },
});

export default function Radio({
  children,
  ...props
}: Omit<RadioProps, "children"> & { children: React.ReactNode }) {
  return (
    <RadioRAC
      {...props}
      className={composeRenderProps(props.className, (className, renderProps) =>
        styles({
          ...renderProps,
          className,
        }),
      )}
    >
      <div className="border-4 border-grey-4 group-selected:border-black size-4 mr-5 rounded-full relative before:absolute before:top-0 before:left-0 before:w-full before:h-full before:rounded-full shrink-0 before:scale-0 group-selected:before:scale-75 before:bg-black before:transition-all transition-all" />
      {children}
    </RadioRAC>
  );
}
